/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @flow */
import { createStyledComponent } from '../../../../../utils';
import Link from '../../../../../Link';

const Big = createStyledComponent('p', { fontSize: '1.5em' });
const Bold = createStyledComponent('p', { fontWeight: 700 });
const Serif = createStyledComponent('p', { fontFamily: 'serif' });
const Small = createStyledComponent('p', { fontSize: '0.75em' });

export default {
  id: 'basic',
  title: 'Example',
  description: 'Links inherit font size, weight, and family.',
  scope: { Big, Bold, Link, Serif, Small },
  source: `
    <div>
      <Big>
        Lorem ipsum dolor sit amet, <Link href="http://example.com">consectetur</Link> adipiscing elit,
      </Big>

      <Small>
        sed do eiusmod tempor <Link href="http://example.com">incididunt</Link> ut labore et dolore magna aliqua.
      </Small>

      <Bold>
        Ut enim <Link href="http://example.com">ad minim veniam</Link> quis nostrud exercitation
      </Bold>

      <Serif>
        ullamco laboris <Link href="http://example.com">nisi ut</Link> aliquip ex ea commodo consequat.
      </Serif>
    </div>`
};



// WEBPACK FOOTER //
// ./src/website/app/demos/Link/examples/link.js